import {
    RawRunExpectancy,
    FlattenedRunExpectancy,
    RunExpectancyRunners,
    FlattenedCountRow,
} from '../types/run-expectancy.ts'

export function flattenRunExpectancyByCount(
    rows: RawRunExpectancy[]
): FlattenedRunExpectancy[] {
    const map = new Map<string, FlattenedRunExpectancy>()

    rows.forEach((d) => {
        const key = `${d.runners_on_cd}|${d.ball_count}|${d.strike_count}`

        if (!map.has(key)) {
            map.set(key, {
                runners_on_cd: d.runners_on_cd,
                bases: d.bases,
                outs: d.outs,
                ball_count: d.ball_count,
                strike_count: d.strike_count,
                run_expectancy_0_out: null,
                run_expectancy_1_out: null,
                run_expectancy_2_out: null,
            })
        }

        const row = map.get(key)! // Use ! because we know it was just set or existed

        const outKey =
            `run_expectancy_${d.outs}_out` as keyof FlattenedRunExpectancy
        ;(row[outKey] as number | null) = d.run_expectancy
    })

    return Array.from(map.values())
}

export function flattenRunExpectancyByRunners(
    data: RunExpectancyRunners[]
): FlattenedCountRow[] {
    const balls = [0, 1, 2, 3]
    const strikes = [0, 1, 2] as const

    // Index run expectancy by count string: "B-S"
    const lookup = new Map<string, number>(
        data.map((d) => [`${d.ball_count}-${d.strike_count}`, d.run_expectancy])
    )

    // Index bases by ball count (first match wins)
    const basesByBall = new Map<number, string>()
    data.forEach((d) => {
        if (!basesByBall.has(d.ball_count)) {
            basesByBall.set(d.ball_count, d.bases)
        }
    })
    const { outs } = data?.[0] ?? 0

    return balls.map((ballCount) => {
        // Initialize the row with explicit types
        const row: FlattenedCountRow = {
            outs,
            balls: ballCount,
            bases: basesByBall.get(ballCount) ?? '',
            run_exp_strikes_0: null,
            run_exp_strikes_1: null,
            run_exp_strikes_2: null,
        }

        strikes.forEach((strikeCount) => {
            const key = `run_exp_strikes_${strikeCount}`
            row[key] = lookup.get(`${ballCount}-${strikeCount}`) ?? null
        })

        return row
    })
}
